var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSgiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.29 20.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#62bb46;}.cls-2{fill:#ffd600;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SGI CMYK logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.07,23.39l5.3-17.33a4.56,4.56,0,0,1,4.36-3.23H66.8l-5,16.48a5.77,5.77,0,0,1-5.52,4.08Z",
    transform: "translate(-4.66 -2.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.44,23.39l5.47-17.9a3.76,3.76,0,0,1,3.6-2.66h1.25l-5.5,18a3.65,3.65,0,0,1-3.49,2.58Z",
    transform: "translate(-4.66 -2.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.41,23.39,73.89,5.46a3.72,3.72,0,0,1,3.56-2.63h.92l-5.5,18a3.66,3.66,0,0,1-3.49,2.58Z",
    transform: "translate(-4.66 -2.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.52,23.39,80.09,5.17a3.32,3.32,0,0,1,3.17-2.34h.64L78.3,21.15a3.17,3.17,0,0,1-3,2.24Z",
    transform: "translate(-4.66 -2.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81,23.39l5.6-18.32a3.18,3.18,0,0,1,3-2.24H90L84.35,21.17a3.13,3.13,0,0,1-3,2.22Z",
    transform: "translate(-4.66 -2.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.4,11h0a4.29,4.29,0,0,0,4.3,4.3h6.16l-1.07,3.5H35.07l3.46-11.3H52.78a4.62,4.62,0,0,0,4.41-3.26l.42-1.37H38.72a4.6,4.6,0,0,0-4.41,3.26L30.57,18.32a3.92,3.92,0,0,0,3.75,5.07h16a3.68,3.68,0,0,0,3.52-2.61l1.51-4.93A3.8,3.8,0,0,0,51.68,11Z",
    transform: "translate(-4.66 -2.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.41,11l1.07-3.5H26.71a4.64,4.64,0,0,0,4.44-3.28l.41-1.35H12.68A4.6,4.6,0,0,0,8.27,6.08L6.77,11a3.29,3.29,0,0,0,3.15,4.25H24.81l-1.07,3.5H10.32a5.74,5.74,0,0,0-5.48,4.06l-.18.58H24.23a3.69,3.69,0,0,0,3.53-2.61l1.56-5.1A3.66,3.66,0,0,0,25.82,11Z",
    transform: "translate(-4.66 -2.82)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgiLogo);
export default __webpack_public_path__ + "static/media/sgi_logo.c864f1e9377feef7761f322bedd48fef.svg";
export { ForwardRef as ReactComponent };